import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="wbmp" transform="translate(-565 -294)">
        <g id="file-extension" transform="translate(565 294)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#5ab2a5"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#1c6258"
          />
        </g>
        <g
          id="Сгруппировать_4326"
          data-name="Сгруппировать 4326"
          transform="translate(1.317 0.266)"
        >
          <path
            id="Контур_812"
            data-name="Контур 812"
            d="M-6.255-.766v-3.5H-5a1.78,1.78,0,0,1,1.028.248.824.824,0,0,1,.352.719.833.833,0,0,1-.125.464.728.728,0,0,1-.368.284.738.738,0,0,1,.421.269.783.783,0,0,1,.147.481.927.927,0,0,1-.326.773,1.55,1.55,0,0,1-.965.263Zm.844-1.488v.839h.553a.526.526,0,0,0,.351-.1.366.366,0,0,0,.123-.294.388.388,0,0,0-.435-.44Zm0-.553h.44a.626.626,0,0,0,.394-.1A.358.358,0,0,0-4.459-3.2a.376.376,0,0,0-.127-.319A.683.683,0,0,0-5-3.614h-.413Zm3.489-1.459.781,2.435.779-2.435H.749v3.5H-.1v-.817l.082-1.673L-.862-.766H-1.42l-.849-2.493.082,1.675v.817H-3.03v-3.5Zm4.1,2.312V-.766H1.334v-3.5h1.4a1.627,1.627,0,0,1,.71.148,1.114,1.114,0,0,1,.478.421,1.149,1.149,0,0,1,.169.619,1.013,1.013,0,0,1-.367.818,1.521,1.521,0,0,1-1.006.306Zm0-.651h.553A.521.521,0,0,0,3.1-2.727a.455.455,0,0,0,.129-.346A.563.563,0,0,0,3.1-3.465a.468.468,0,0,0-.361-.149H2.178Z"
            transform="translate(576.929 309)"
            fill="#fff"
          />
          <path
            id="Контур_827"
            data-name="Контур 827"
            d="M.791-1.635,1.144-3.7H2.189L1.364-.2H.442L-.137-2.275-.719-.2h-.922l-.825-3.5h1.045l.346,2.112L-.519-3.7h.76Z"
            transform="translate(568.064 308.433)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export default memo(Icon);
